<template>
  <BreadCrumb />
  <div v-if="loading">
    <LoaderAnimation />
  </div>
  <div v-else>
    <div v-if="plants.length > 0">
      <div class="category">
        <CardPlant
          v-for="plant in plants"
          :plant="plant"
          :key="plant.id"
          isSmall="true"
        />
      </div>
    </div>
    <div v-else><NoData /></div>
  </div>
</template>
<script>
import CardPlant from "../Cards/CardPlant.vue";
import NoData from "../NoData/NoData.vue";
import BreadCrumb from "../BreadCrumb/BreadCrumb.vue";
import LoaderAnimation from "../LoaderAnimation/LoaderAnimation.vue";
import PlantService from "@/services/PlantService.js";

export default {
  name: "CategoryPage",
  components: {
    CardPlant,
    LoaderAnimation,
    NoData,
    BreadCrumb,
  },
  data() {
    return {
      plants: [],
      loading: false,
    };
  },
  methods: {
    async fetchDataPlants(keyCategory) {
      this.loading = true;
      PlantService.getPlantsByCategory(keyCategory)
        .then((res) => {
          this.plants = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$watch(
      () => this.$route.params,
      (toParams) => {
        this.fetchDataPlants(toParams.keyCategory);
      }
    );
  },
  created() {
    this.fetchDataPlants(this.$route.params.keyCategory);
  },
};
</script>
<style lang="scss" scoped>
.content-home-title {
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 1rem;
}
.content-subtitle {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 32px;
}
.container {
  width: 60rem;
  margin-left: auto;
  margin-right: auto;
}
.category {
  display: grid;
  grid-gap: 36px;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  list-style: none;
}
</style>
